import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { AppModule, DeviceType } from '@/store/modules/app';
var WIDTH = 992; // refer to Bootstrap's responsive design
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    _classCallCheck(this, default_1);
    return _callSuper(this, default_1, arguments);
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "device",
    get: function get() {
      return AppModule.device;
    }
  }, {
    key: "sidebar",
    get: function get() {
      return AppModule.sidebar;
    }
  }, {
    key: "onRouteChange",
    value: function onRouteChange() {
      if (this.device === DeviceType.Mobile && this.sidebar.opened) {
        AppModule.CloseSideBar(false);
      }
    }
  }, {
    key: "beforeMount",
    value: function beforeMount() {
      window.addEventListener('resize', this.resizeHandler);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var isMobile = this.isMobile();
      if (isMobile) {
        AppModule.ToggleDevice(DeviceType.Mobile);
        AppModule.CloseSideBar(true);
      }
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      window.removeEventListener('resize', this.resizeHandler);
    }
  }, {
    key: "isMobile",
    value: function isMobile() {
      var rect = document.body.getBoundingClientRect();
      return rect.width - 1 < WIDTH;
    }
  }, {
    key: "resizeHandler",
    value: function resizeHandler() {
      if (!document.hidden) {
        var isMobile = this.isMobile();
        AppModule.ToggleDevice(isMobile ? DeviceType.Mobile : DeviceType.Desktop);
        if (isMobile) {
          AppModule.CloseSideBar(true);
        }
      }
    }
  }]);
}(Vue);
__decorate([Watch('$route')], default_1.prototype, "onRouteChange", null);
default_1 = __decorate([Component({
  name: 'ResizeMixin'
})], default_1);
export default default_1;